(() => {
  'use strict';
  function init(root) {
    const campaign = root.querySelector('[data-campaign]');
    if (!campaign || campaign.dataset.initialized) return;
    campaign.dataset.initialized = 'true';
    const video = campaign.querySelector('[data-campaign-video]');
    const toggle = campaign.querySelector('[data-video-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    let userPaused = false;
    let visible = false;
    let loaded = false;
    const update = () => {
      toggle.textContent = video.paused ? 'Play demonstration ▶' : 'Pause demonstration Ⅱ';
      toggle.setAttribute('aria-label', video.paused ? 'Play product demonstration' : 'Pause product demonstration');
    };
    const play = () => {
      if (!video.dataset.src) return;
      if (!loaded) { video.src = video.dataset.src; loaded = true; }
      video.play().catch(update);
    };
    if (video && toggle && video.dataset.src) {
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        if (video.paused) {userPaused = false; play();}
        else {userPaused = true; video.pause();}
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('error', () => {toggle.textContent = 'Replay demonstration ▶';});
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          if (visible && !userPaused && !reduceMotion.matches && !saveData && !document.hidden) play();
          else video.pause();
        }, {threshold:0.25});
        observer.observe(video);
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (visible && !userPaused && !reduceMotion.matches && !saveData) play();
      });
      reduceMotion.addEventListener('change', () => {if (reduceMotion.matches) video.pause();});
    }
    const sticky = campaign.querySelector('[data-campaign-sticky]');
    const hero = campaign.querySelector('.cp-hero');
    const buy = campaign.querySelector('#choose');
    if (sticky && hero && buy && 'IntersectionObserver' in window) {
      let heroPassed = false;
      let buyVisible = false;
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === hero) heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (entry.target === buy) buyVisible = entry.isIntersecting;
        }
        sticky.hidden = !heroPassed || buyVisible;
      });
      observer.observe(hero);
      observer.observe(buy);
    }
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
